import React from 'react';
import { useTranslation } from 'react-i18next';
import { Car } from 'lucide-react';

const ComingSoonPlaceholder = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`relative w-full h-full bg-slate-100 overflow-hidden flex flex-col items-center justify-center ${className}`}
      data-testid="coming-soon-placeholder"
    >
      <div
        className="absolute inset-0 opacity-[0.4]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(148,163,184,0.25) 1px, transparent 1px), linear-gradient(90deg, rgba(148,163,184,0.25) 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }}
      />

      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-blue-100 blur-3xl pointer-events-none" />

      <div className="relative z-10 text-center px-6">
        <div className="w-14 h-14 mx-auto rounded-full bg-white border border-blue-100 flex items-center justify-center text-blue-900 mb-4 shadow-sm">
          <Car size={24} strokeWidth={1.6} />
        </div>
        <p className="text-blue-900 text-[11px] tracking-[0.25em] uppercase font-bold mb-2">
          {t('common.comingSoon', 'Bientôt disponible')}
        </p>
        <p className="text-slate-700 text-lg font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>
          {t('coming.headline', 'Nouveau véhicule')}
        </p>
        <p className="text-slate-500 text-xs mt-1">
          {t('coming.subline', 'En préparation pour vous')}
        </p>
      </div>
    </div>
  );
};

export default ComingSoonPlaceholder;
